export class GettyOrderDetailModel {
    public name: string;
    public invoiceNumber: string;
    public salesDate: any;
    public customerName: string;
    public assetDescription: string;
    public assetNumber: string;
    public isAlreadyExist: boolean;
    public imageId: number | undefined;
    public grossRoyaltyInUSD: number;
    public isValid: boolean;
}
